import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectCompanyCode } from '../../shared/store/actions';
import { NavLink } from 'react-router-dom';

class LinkCellRenderer extends PureComponent {
  static propTypes = {
    value: PropTypes.string.isRequired,
    selectCompanyCode: PropTypes.func.isRequired,
  };

  selectCompanyCode = () => {
    const { value } = this.props;
    this.props.selectCompanyCode(value);
  };

  render() {
    const { value } = this.props;

    return (
      <NavLink
        className="cell-link"
        onClick={this.selectCompanyCode}
        to="/provision"
      >
        {value}
      </NavLink>
    );
  }
}

export default connect(null, { selectCompanyCode })(LinkCellRenderer);
